module.exports = __webpack_public_path__ + "img/felc-职教赛区.15e5dc78.png";